const BH = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20512%20341.3'%3e%3cpolygon%20fill='%23D80027'%20points='0,0%20512,0%20512,341.3%200,341.3%20'/%3e%3cpolygon%20fill='%23FFFFFF'%20points='222.8,34.3%20137.6,68.5%20222.8,102.6%20137.6,136.7%20222.8,170.8%20137.6,204.9%20222.8,239%20137.6,273.1%20222.8,307.2%20137.6,341.3%200,341.3%200,0%20137.6,0%20'/%3e%3c/svg%3e";
export {
  BH as default
};
//# sourceMappingURL=BH.svg.es.js.map
